import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { wbp, reduceResolution } from 'Theme';

export const useCommonStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'block',
            justifyContent: 'center',
            background: 'white',
            height: '100%',
            width: '100%'
        },
        iframe: {
            width: '100%',
            height: '100%',
            border: 'none'
        },
        contentInsights: {
            width: '100%',
            height: '100%',
            border: 'none',
            padding: '25px',
            paddingTop: '45px',
            [theme.breakpoints.down('sm')]: {
                height: 'auto',
                minHeight: '100%',
                paddingBottom: '90px'
            }
        },
        titleDefault: {
            fontSize: '24px',
            fontWeight: 600,
            marginBottom: '25px',
            marginTop: '0px'
        },
        cardsContent: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            gap: '20px'
        },
        subViewTitle: {
            'display': 'flex',
            'alignItems': 'center',
            'marginBottom': '30px',
            '& h2': {
                marginBottom: '0px'
            }
        },
        backIcon: {
            cursor: 'pointer',
            marginRight: '8px'
        },
        containerSearch: {
            paddingBottom: 21,
            borderRadius: '12px'
        },
        input: {
            'borderRadius': 30,
            'background': '#FFFFFF !important',

            '& input': {
                '&::placeholder': {
                    opacity: 1,
                    color: '#7A7A7A'
                },

                [theme.breakpoints.down('sm')]: {
                    height: 47,
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: 14
                }
            },
            '& .MuiInputAdornment-root': {
                'opacity': 0.3,
                'marginRight': 0,
                'pointer-events': 'none',

                '& svg': {
                    cursor: 'default'
                },
                [theme.breakpoints.down('md')]: {
                    'opacity': 1,
                    '& svg': {
                        color: '#000',
                        fontWeight: 400
                    }
                }
            }
        },
        inputContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 11px',
            borderRadius: '12px',
            backgroundColor: '#F1F1F1',
            [theme.breakpoints.up('md')]: {
                paddingLeft: '22px',
                paddingRight: '22px',
                paddingBottom: '14px'
            }
        },
        inputBox: {},
        search: {
            [theme.breakpoints.down(wbp)]: {
                marginLeft: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginLeft: '5px'
            }
        },
        iconSearch: {
            [theme.breakpoints.down(wbp)]: {
                paddingLeft: `${reduceResolution(5)}px`,
                height: `${reduceResolution(18)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingLeft: '5px',
                height: '18px'
            }
        },
        resultNotFound: {
            [theme.breakpoints.down('sm')]: {
                marginTop: '27px'
            },
            [theme.breakpoints.only('md')]: {
                marginTop: '43px'
            },
            [theme.breakpoints.only('lg')]: {
                marginTop: '57px'
            },
            [theme.breakpoints.up('xl')]: {
                marginTop: '87px'
            }
        }
    })
);
